// extracted by mini-css-extract-plugin
module.exports = {"root":"AfterBackImages_root__3l2u6","title":"AfterBackImages_title__18aSv","images":"AfterBackImages_images__RqHti"};